// src/services/eventService.js
import axios from "axios";
import { apiClient } from "./apiClient";

const CDN_PREFIX =
  (process.env.REACT_APP_IMAGE_BASE_URL || "https://cdn.connectummah.com/myuploadfiles/")
    .replace(/\/+$/, "") + "/";

export const PLACEHOLDER_IMAGE = "https://placehold.co/600x400?text=No+Image";
const LOCAL_EVENTS_BASE = process.env.REACT_APP_LOCAL_API_BASE || "http://localhost:5000/api";

// helpers
function isAbsoluteUrl(url) {
  return typeof url === "string" && /^https?:\/\//i.test(url);
}
function joinCdn(path) {
  if (!path || typeof path !== "string") return null;
  const clean = path.replace(/^\/+/, "");
  return isAbsoluteUrl(path) ? path : `${CDN_PREFIX}${clean}`;
}
function extractImageFromImagesArray(images) {
  if (!Array.isArray(images)) return null;
  const cleaned = images
    .filter(Boolean)
    .map((x) => (typeof x === "string" ? { imageLink: x } : x));

  const candidate =
    cleaned.find((i) => i?.imageLink) ||
    cleaned.find((i) => i?.image_Path || i?.imagePath || i?.path || i?.url) ||
    null;

  if (!candidate) return null;

  const raw =
    candidate.imageLink ??
    candidate.image_Path ??
    candidate.imagePath ??
    candidate.path ??
    candidate.url;

  return joinCdn(raw);
}

export async function getEventsForMasjid(masjidId) {
  const normalizeEvents = (payload) => {
    const events = Array.isArray(payload) ? payload : payload?.data || [];

    return events.map((event) => {
      const topLevelRaw =
        event?.image ??
        event?.imageLink ??
        event?.image_Path ??
        event?.imagePath ??
        event?.url ??
        null;

      const topLevelJoined = topLevelRaw ? joinCdn(topLevelRaw) : null;
      const fromArray = extractImageFromImagesArray(event?.images);
      const finalImage = topLevelJoined || fromArray || PLACEHOLDER_IMAGE;

      return { ...event, image: finalImage };
    });
  };

  try {
    const localRes = await axios.get(`${LOCAL_EVENTS_BASE.replace(/\/+$/, "")}/events/${masjidId}`);
    return normalizeEvents(localRes.data);
  } catch (error) {
    console.warn("Local events endpoint failed, falling back to direct API.", error?.message || error);

    try {
      const res = await apiClient.get(`/CommunityEvent/GetForMasjidId/${masjidId}`);
      return normalizeEvents(res.data);
    } catch (directError) {
      console.error("getEventsForMasjid failed:", directError);
      throw directError;
    }
  }
}
